import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { GameMediaService } from '@core/services/game-media.service';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed, Game, MediaItem, Tournament, UntilDestroy } from '@mtgame/core';
import { SeoService } from '@core/services/seo.service';
import { GameRootService } from '@core/services/game-root.service';

@UntilDestroy
@Component({
  selector: 'mtg-tournament-game-media-dialog',
  templateUrl: './tournament-game-media-dialog.component.html',
  styleUrls: ['./tournament-game-media-dialog.component.scss'],
})
export class TournamentGameMediaDialogComponent implements OnInit, OnDestroy {
  tournament: Tournament;
  game: Game;
  media: MediaItem;

  constructor(
    private gameRootService: GameRootService,
    private gameMediaService: GameMediaService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
  ) {
  }

  ngOnInit(): void {
    combineLatest([
      this.route.params,
      this.gameMediaService.media$.pipe(takeUntil(componentDestroyed(this))),
      this.gameRootService.game$.pipe(takeUntil(componentDestroyed(this))),
    ]).subscribe(([params, media, game]) => {
      game.media = media;
      this.game = game;
      this.media = media.find(item => item.id === +params.mediaId);
      this.seoService.setData({image: this.media.originalPhoto.path});
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.seoService.setData({image: ''});
  }
}
